module.exports = __webpack_public_path__ + "assets/img/topImg1.527e2df2.png";